// extracted by mini-css-extract-plugin
export default {"platform_container":"OtherPlatforms_platform_container__exF0k","platforms":"OtherPlatforms_platforms__4pefQ","item":"OtherPlatforms_item__6uYaN"};